import { VALIDATOR_PATTERNS } from 'src/app/helper/class/app-constant';
import { transformTitle } from 'src/app/helper/class/utilityHelper';
import {
  formBuilderData,
  tableButton,
  tableColum,
  tbl_condition,
  urlConfig,
} from 'src/app/helper/interface/response';
import { userPermission } from 'src/app/helper/interface/user';
import { confirmModalData } from 'src/app/shared/interface/modal-interface';

export const ADDRESS_FORM_DATA: formBuilderData[] = [
  {
    colName: 'street',
    title: 'House No / Plot',
    validator: [{ name: 'required' }],
  },
  { colName: 'address', title: 'Address' },
  {
    colName: 'country',
    type: 'select',
    selectKeyName: 'countryName',
    apiTblName: 'country',
    event: {
      name: 'change',
      apiTblName: 'state',
      valueAssign: 'state',
      resetOnChange: true,
    },
    defaultValue: '1',
    validator: [{ name: 'required' }],
  },
  {
    colName: 'state',
    type: 'select',
    selectKeyName: 'stateName',
    apiTblName: 'state',
    event: {
      name: 'change',
      apiTblName: 'district',
      valueAssign: 'district',
      resetOnChange: true,
    },
    // Not required: state/district/sub-district only apply to countries that use
    // this administrative hierarchy (e.g. India) - a foreign address is still valid without them.
  },
  {
    colName: 'district',
    type: 'select',
    selectKeyName: 'districtName',
    apiTblName: 'district',
    event: {
      name: 'change',
      apiTblName: 'subdistrict',
      valueAssign: 's_district',
      resetOnChange: true,
    },
  },
  {
    colName: 's_district',
    title: 'Sub District',
    type: 'select',
    selectKeyName: 'subDistrictName',
    apiTblName: 'subdistrict',
    event: {
      name: 'change',
      valueAssign: 'panchayatCity',
      apiFunName: 'getPanyatAndCity',
    },
  },
  {
    colName: 'panchayatCity',
    selectKeyName: 'panchayatCityName',
    type: 'select',
    title: 'Panchayat/City',
    event: {
      name: 'change',
      apiFunName: 'getCityVillage',
      valueAssign: 'villageWard',
      addParams: [{ colName: 'type' }],
      valueMap: [{ controlName: 'type', supportKeyName: 'type' }],
    },
    validator: [{ name: 'required' }],
  },
  { colName: 'address_type', readonly: true,defaultValue:'present' },
  {
    colName: 'villageWard',
    selectKeyName: 'villageWardName',
    type: 'select',
    title: 'Village/Ward',
    validator: [{ name: 'required' }],
  },
  {
    colName: 'pincode',
    validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.PINCODE }],
  },
];

export const MODIFY_COL: formBuilderData[] = [
  { colName: 'created_byName', title: 'Created By' },
  { colName: 'created_at', title: 'Created On', type: 'DATETIME' },
  { colName: 'updated_at', title: 'Last Modified', type: 'DATE' },
  { colName: 'last_modify_byName', title: 'Last Modified By' },
];
export const RELIVE_COL: formBuilderData[] = [
  { colName: 'reason_relive', title: 'Reason Relive' },
  { colName: 'effect_from', title: 'Relived On', type: 'DATE' },
  { colName: 'died_on', type: 'DATE', title: 'Died On' },
];
export const APPROVE_COL = [
  ...MODIFY_COL,
  ...[{ colName: 'last_approved_byName', title: 'Approved By' }],
];
export const COMMON_INFO_UPDATE_INFO = [
  { name: 'created_at', type: 'DATE', title: 'Applied On', col: '12' },
  { name: 'updated_at', title: 'Updated On', type: 'DATE', col: '12' },
  { col: '12', name: 'created_byName', title: 'created By' },
  { col: '12', name: 'last_modify_byName', title: 'last Modify By' },
];
export const MODIFY_INFO_UPDATE_INFO = [
  { name: 'description', title: 'Description', col: '12' },
  { name: 'updated_at', title: 'Applied On', type: 'DATE', col: '12' },
  { col: '12', name: 'created_name', title: 'Requested By' },
];
export const DELETE_REMARK_COL: formBuilderData[] = [
  { colName: 'remarks', title: 'Remarks', validator: [{ name: 'required' }] },
];
export const BUTTON_FUN: any = (
  type: any,
  classN: string,
  icon: string,
  title: string,
  cond: tbl_condition[],
  p,
  u: urlConfig,
  conf?: confirmModalData
): any => ({
  type: type,
  class: classN,
  icon: icon,
  title: transformTitle(title),
  label: transformTitle(title),
  condition: cond,
  permission: p,
  url: u,
  confirmModal: conf,
});
export const VIEW_BTN: any = (
  cond: tbl_condition[],
  p: userPermission = {} as userPermission,
  u: urlConfig = {} as urlConfig,
  t = 'VIEW',
  c = 'bg-orange',
  i = 'pi pi-eye',
  ti = t
) => BUTTON_FUN(t, c, i, ti, cond, p, u);
export const ADD_BTN: any = (
  cond: tbl_condition[],
  p: userPermission = {} as userPermission,
  u: urlConfig = {} as urlConfig,
  t = 'ADD',
  c = 'btn-primary',
  i = 'pi pi-plus',
  ti = t
) => BUTTON_FUN(t, c, i, ti, cond, p, u);
export const EDIT_BTN: any = (
  cond: tbl_condition[],
  p: userPermission = {} as userPermission,
  u: urlConfig = {} as urlConfig,
  t = 'EDIT',
  c = 'btn-info',
  i = 'pi pi-pencil',
  ti = t
) => BUTTON_FUN(t, c, i, ti, cond, p, u);
export const DELETE_BTN: any = (
  cond: tbl_condition[],
  p: any = {},
  u: urlConfig = {} as urlConfig,
  conf: confirmModalData = {} as confirmModalData,
  t = 'DELETE',
  c = 'btn-danger',
  i = 'pi pi-trash',
  ti = t
) => BUTTON_FUN(t, c, i, ti, cond, p, u, conf);
export const DEFAULT_BTN: tableButton[] = [VIEW_BTN(), EDIT_BTN()];
export const DOWNLOAD_BTN: any = (
  cond: tbl_condition[],
  p: any,
  t = 'DOWNLOAD',
  c = 'btn-info',
  i = 'pi pi-cloud-download',
  ti = 'Download',
  u: urlConfig = {} as urlConfig
) => BUTTON_FUN(t, c, i, ti, cond, p, u);
export const CREATED_TBL: tableColum[] = [
  {
    colName: 'created_byName',
    title: 'Created By',
  },
  {
    colName: 'created_at',
    title: 'Created On',
    colType: 'DATE',
    filterCol: {
      type: 'DATE',
    },
  },
];
export const LAST_UPDATE_TBL: tableColum[] = [
  {
    colName: 'last_modify_byName',
    title: 'Updated By',
  },
  {
    colName: 'updated_at',
    title: 'Update On',
    colType: 'DATE',
    filterCol: {
      type: 'DATE',
    },
  },
];
